import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'

function getOfficeTypeText (types, vm) {
  let textName = ''
  types.forEach((el, indx) => {
    textName = vm.getOfficeTypeName(el.office_type_id)
    if (indx + 1 < types.length) {
      textName += ', '
    }
  })
  return textName
}

const exportPdfDetails = async (baseUrl, uri, orgId, vm) => {
    try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = []
      pdfContent.push(
        {
          table: {
            style: 'tableData',
            headerRows: 0,
            widths: ['25%', '50%', '25%'],
            body: [
              [
                { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 4 },
                { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                { image: reportHeadData.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 4 }
              ],
              [
                {},
                { text: reportHeadData.orgName ? reportHeadData.orgName : (vm.currentLocale === 'en' ? 'Bangladesh National Social Welfare Council' : 'বাংলাদেশ জাতীয় সমাজকল্যাণ পরিষদ'), style: 'header2', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportHeadData.heading, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportHeadData.address, style: 'address', alignment: 'center' },
                {}
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        }
      )

        pdfContent.push({ text: '', style: 'fertilizer' })
        const currentLocale = vm.currentLocale
        const detailsData = vm.detailsFormData
        const rows = [
          [
            { text: detailsData.circular_memo_no, style: 'tdCustom3', alignment: 'left' },
            { text: vm.$t('globalTrans.date') + ' : ' + vm.formatDate(detailsData.updated_at), style: 'tdCustom3', alignment: 'left' }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 1,
            widths: ['80%', '20%'],
            body: rows
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })
        pdfContent.push({ text: currentLocale === 'bn' ? detailsData.title_bn : detailsData.title_en, marginTop: 5, alignment: 'center', bold: true })
        if (currentLocale === 'en') {
          pdfContent.push({ text: 'Bangladesh National Social Welfare Council will provide a one-time financial grant in favor of registered voluntary social welfare organizations in the fiscal year ' + detailsData.fiscal_year_en + '. Within the specified period, the social welfare institutions having the following qualifications are requested to submit the application form along with the necessary documents to the concerned office in the prescribed form:-', marginTop: 10, fontSize: 11 })
        } else {
          pdfContent.push({ text: 'বাংলাদেশ জাতীয় সমাজকল্যাণ পরিষদ হতে ' + detailsData.fiscal_year_bn + ' অর্থবছরে নিবন্ধিত স্বেচ্ছাসেবী সমাজকল্যাণ প্রতিষ্ঠানসমূহের অনুকূলে এককালীন আর্থিক অনুদান প্রদান করা হবে। নির্দিষ্ট সময়ের মধ্যে নিম্নবর্ণিত যোগ্যতা সম্পন্ন সমাজকল্যাণমূলক প্রতিষ্ঠানসমূহকে নির্ধারিত ফরমে সংশ্লিষ্ট কার্যালয়ে প্রয়োজনীয় কাগজপত্রসহ আবেদনপত্র জমাদানের জন্য অনুরোধ করা হলো:-', marginTop: 10, fontSize: 12 })
        }

        pdfContent.push({ text: '', style: 'fertilizer' })
        const allRows = [
          [
            { text: vm.$t('grant_process.ins_type'), style: 'th', alignment: 'center', bold: true },
            { text: vm.$t('grant_process.application_place'), style: 'th', alignment: 'center', bold: true },
            { text: vm.$t('grant_process.application_fee'), style: 'th', alignment: 'center', bold: true }
          ]
        ]
        vm.services.forEach((item, index) => {
          allRows.push([
            { text: '(' + vm.$n(index + 1) + ') ' + (currentLocale === 'en' ? item.text_en : item.text_bn), alignment: 'left', style: 'td' },
            { text: getOfficeTypeText(item.office_type, vm), alignment: 'center', style: 'td' },
            { text: vm.$n(item.fee), alignment: 'center', style: 'td' }
          ])
        })
        pdfContent.push({
          table: {
            headerRows: 1,
            widths: ['45%', '35%', '20%'],
            body: allRows
          }
        })

        const row1 = [
          [
            { text: vm.$t('grant_process.deadline'), style: 'tdCustom3', alignment: 'left' },
            { text: vm.formatDate(detailsData.deadline), style: 'tdCustom3', alignment: 'left' }
          ],
          [
            { text: vm.$t('globalTrans.description'), style: 'tdCustom3', alignment: 'left' },
            { text: currentLocale === 'en' ? detailsData.description_en : detailsData.description_bn, style: 'tdCustom3', alignment: 'left' }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 1,
            widths: ['20%', '80%'],
            body: row1
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })

      var docDefinition = {
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'portrait',
        styles: {
          th: {
            fontSize: (i18n.locale === 'bn') ? 12 : 11,
            margin: [3, 3, 3, 3]
          },
          td: {
            fontSize: (i18n.locale === 'bn') ? 11 : 10,
            margin: [3, 3, 3, 3]
          },
          fertilizer: {
            margin: [5, 0, 0, 5]
          },
          header: {
              fontSize: 16,
              bold: true,
              margin: [0, 0, 0, 0]
          },
          org: {
              fontSize: 13,
              bold: true,
              margin: [0, -25, 10, 5]
          },
          address: {
              fontSize: 11,
              margin: [0, 0, 0, 5]
          },
          tdCustom3: {
            fontSize: (i18n.locale === 'bn') ? 10 : 8,
            margin: [0, 9, 0, 0]
          },
          hh: {
              fontSize: 13,
              bold: true,
              margin: [10, 10, 25, 20]
          }
        }
      }
      pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {}
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
